import React from 'react'
import { TabContainer as BaseTabContainer } from '@/components/organisms/settings/tab-container'
import { SettingTab } from '@/components/molecules/settings/setting-tab'
import { css } from '@emotion/core'

interface Props {
  currentTab: string
  contentRef?: React.RefObject<HTMLDivElement>
}
const TabLayout: React.FC<Props> = props => {
  return (
    <SettingTab
      currentTab={props.currentTab}
      tabs={[
        {
          name: 'A/R List',
          path: '/accounts-receivable-manager',
        },
        {
          name: 'A/R Balance',
          path: '/accounts-receivable-manager/balance',
        },
        {
          name: 'Deposit history',
          path: '/accounts-receivable-manager/receipt',
        },
        {
          name: 'Invoice list',
          path: '/invoice-manager',
        },
      ]}
    />
  )
}

export const TabContainer: React.FC<Props> = props => {
  return (
    <BaseTabContainer tabComponent={<TabLayout currentTab={props.currentTab} />} contentRef={props.contentRef}>
      {props.currentTab === 'Invoice list' ? props.children : <div css={containerStyle}>{props.children}</div>}
    </BaseTabContainer>
  )
}

const containerStyle = css({
  margin: 32,
  marginTop: 0,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 900,
  '.headline-block': {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 16,
  },
  '.indicator-block': {
    display: 'flex',
    justifyContent: 'space-around',
    paddingTop: 16,
    gap: 16,
    '> div': {
      height: 110,
      border: '1px solid rgb(217, 217, 217)',
      borderRadius: 5,
      color: '#272727',
      padding: '16px 24px',
      flex: 1,
      lineHeight: 1.5,
      minWidth: 200,
      '.sub-title': { fontSize: 14, fontWeight: 'bold', paddingBottom: 16 },
      '.title': { fontSize: 22, fontWeight: 'bold' },
    },
  },
  '.table-description-block': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 16,
    '.sub-title': {
      fontSize: 12,
      fontWeight: 'bold',
      color: 'rgb(103, 103, 103)',
    },
  },
  '.table-block': {
    marginTop: 16,
    flexGrow: 1,
    '> div': {
      overflow: 'hidden',
      border: '1px solid rgb(217, 217, 217)',
      borderRadius: 5,
    },
  },
  '.table-block, .sub-table-block': {
    '.empty-table': { display: 'flex', alignItems: 'center', justifyContent: 'center', height: 160 },
    '.table-header': {
      background: 'rgb(245, 245, 245)',
      '> .table-row': {
        '> .table-cell': { color: '#676767', fontWeight: 'bold', fontSize: 12 },
      },
    },
    '.table-body': {
      '> .table-row': {
        minHeight: 40,
        borderTop: '1px solid rgb(238, 238, 238)',
        ':first-of-type': { borderTop: 'none' },
        '> .table-cell': { color: '#272727', fontSize: 14 },
      },
    },
    '.table-row': {
      display: 'flex',
      alignItems: 'center',
    },
    '.table-cell': {
      margin: 8,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      ':first-of-type': { marginLeft: 16 },
      ':end-of-type': { marginRight: 16 },
    },
  },
})
